import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function CTA() {
  const {
    t
  } = useLanguage();
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-20px',
    amount: 0.2
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="mt-12 md:mt-20 py-10 md:py-16 px-5 md:px-8 bg-gradient-to-br from-[#2C4A3E] to-[#3D5F4E] rounded-lg border-[3px] border-[#D4A574] shadow-xl text-center" data-id="element-11">
      <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#FBF8F3] mb-6 md:mb-8" data-id="element-12">
        {t.cta.title}
      </h2>

      <ul className="space-y-3 md:space-y-4 text-base md:text-lg text-[#FBF8F3] mb-8 md:mb-12 max-w-2xl mx-auto text-left" data-id="element-13">
        {t.cta.items.map((item, index) => <li key={index} className="flex items-start" data-id="element-14">
            <span className="text-[#D4A574] mr-3" data-id="element-15">•</span>
            <span data-id="element-16">{item}</span>
          </li>)}
      </ul>

      <p className="text-xl md:text-2xl font-serif text-[#FBF8F3] mb-6 md:mb-8 italic px-2" data-id="element-17">
        {t.cta.subtitle}
      </p>

      <motion.a href="https://www.mentefluir.com/cart/44741027889199:1" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} className="inline-block bg-gradient-to-br from-[#E8B86D] via-[#D4A574] to-[#C87941] text-[#2C4A3E] px-8 md:px-12 py-4 md:py-5 rounded-full text-lg md:text-xl font-semibold transition-all duration-300" data-id="element-18">
        {t.cta.button}
      </motion.a>

      <p className="text-[#FBF8F3] mt-6 md:mt-8 text-base md:text-lg" data-id="element-19">
        {t.cta.closing}
      </p>
    </motion.section>;
}